import "./home.js";
import Internal_3838444105 from "react-dom";
import Internal_1493001052 from "react";
import Internal_3034802077 from "./components/banner-slider";
import Internal_2980243983 from "./containers/search-box";
import Internal_3377008194 from "./components/recommend-list";
import "../layouts/main.njk";
import "../host-guide/macros/list.njk";
import "./components/insurance/index.njk";
import "./components/bb-list/index.njk";
import "./components/bb-stories/index.njk";
import "../layouts/components/bottom-cover/miniapp-aside.njk";
$__renderReact(Internal_3034802077, "banner-slider", "hydrate")
$__renderReact(Internal_2980243983, "J-searchbox", "hydrate")
$__renderReact(Internal_3377008194, "J-product", "hydrate")
function $__renderReact(Component, domId, renderMethod = 'hydrate') {
  const dom = window.document.getElementById(domId)
  if (!dom) return
  const propsNode = window.document.getElementById('r-props-' + domId)
  const propsNodeContent = (propsNode && propsNode.innerHTML) || ''
  const propsContent = propsNodeContent.replace(/^\s*<!--\s*|\s*-->\s*$/g, '').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
  const props = JSON.parse(propsContent)
  const children = props.children || null
  delete props.children
  Internal_3838444105[renderMethod](Internal_1493001052.createElement(Component, props, children), dom)
}
require("./home.less");